import { ModifyProfileInterface } from "../../domain/interface/modify_profile_interface";
import { UserRepository } from "../../domain/repository/user_repository";
import { UserApiService } from "../data_source/remote/user_api_service";

export class UserRepositoryImpl implements UserRepository {
    private userApiService: UserApiService;

    constructor() {
      this.userApiService = new UserApiService();
    }

    async modifyProfile(newProfile: ModifyProfileInterface): Promise<void> {
        const formData = new FormData();
        
        if (newProfile.firstname !== undefined) {
            formData.append('firstname', newProfile.firstname);
        }
        
        if (newProfile.lastname !== undefined) {
            formData.append('lastname', newProfile.lastname);
        }
        
        if (newProfile.description !== undefined) {
            formData.append('description', newProfile.description);
        }
        
        if (newProfile.picture !== undefined && newProfile.picture !== null) {
            formData.append('picture', newProfile.picture);
        }

        if (newProfile.communication !== undefined) {
            formData.append('communication', newProfile.communication.toString());
        }

        if (newProfile.code !== undefined) {
            formData.append('code', newProfile.code);
        }

        if (newProfile.language !== undefined) {
            formData.append('language', newProfile.language);
        }

        const response = await this.userApiService.modifyProfile(formData);
        
        if (response.status !== 200) {
            throw new Error("Failed to modify user profile");
        }
    }
}